// Simple VRP color management for vehicles

const VEHICLE_COLORS = [
  '#1f77b4', // Blue
  '#ff7f0e', // Orange  
  '#2ca02c', // Green
  '#d62728', // Red
  '#9467bd', // Purple
  '#8c564b', // Brown
  '#e377c2', // Pink
  '#7f7f7f', // Gray
  '#bcbd22', // Olive
  '#17becf'  // Cyan
];

// Simple color manager
export const globalColorManager = {
  getVehicleColor(vehicleId) {
    const index = (vehicleId - 1) % VEHICLE_COLORS.length;
    return VEHICLE_COLORS[index];
  }
};